import './index.scss';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import React from 'react';
import { DropdownButton } from 'react-bootstrap';
import { useNotifications } from '~/providers/notifications';
import Notification from './notification';
const NotificationMenu = () => {
    const { notifications, loadingNotifications } = useNotifications();
    const hasUnread = notifications === null || notifications === void 0 ? void 0 : notifications.some(notification => notification.isRead === false);
    const titleIcon = React.createElement("span", { className: 'fas fa-bell menu-icon bell-btn' });
    const hasNotifications = (notifications === null || notifications === void 0 ? void 0 : notifications.length) > 0;
    return (React.createElement("div", { className: 'notification-dropdown-menu', "data-testid": 'notification-menu' },
        hasUnread && React.createElement("div", { className: 'unread-dot' }),
        React.createElement(DropdownButton, { "data-testid": 'header-navigation-notification-button', alignRight: true, variant: 'default', title: titleIcon },
            React.createElement("div", { className: 'notifications-container' },
                React.createElement("div", { className: 'header' }, "Notifications"),
                loadingNotifications && (React.createElement("div", { className: `loading ${hasNotifications && 'syncing'}` },
                    React.createElement(LoadingElement, { isLightBackground: true, text: 'Syncing Notification' }))),
                !hasNotifications && !loadingNotifications && (React.createElement("div", { className: 'empty-inbox' },
                    React.createElement("i", { className: 'fas fa-inbox icon' }),
                    React.createElement("h4", null, "Nothing to see here!"))),
                React.createElement("div", { className: 'notifications' }, hasNotifications &&
                    notifications.map(notification => (React.createElement(Notification, { key: notification.id, notification: notification }))))))));
};
export default NotificationMenu;
